import { render } from "./HighlightsSlick.vue?vue&type=template&id=79896d02"
import script from "./HighlightsSlick.vue?vue&type=script&lang=js"
export * from "./HighlightsSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/HighlightsSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79896d02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79896d02', __exports__)) {
    api.reload('79896d02', __exports__)
  }
  
  module.hot.accept("./HighlightsSlick.vue?vue&type=template&id=79896d02", () => {
    api.rerender('79896d02', render)
  })

}


export default __exports__